import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasAsset',
  standalone: true,
})
export class HasAssetPipe implements PipeTransform {
  public transform = (isin: string, assets) => !!assets?.some((asset: { isin: string }) => asset.isin === isin);
}
